export default __webpack_public_path__ + "static/media/119.9bc47bc0.svg";